import styled, { css } from 'styled-components';
import { FONTS, COLORS } from '@app/src/ui';

interface Props {
  disabled?: boolean;
  error?: string;
}

export const InputTextWrapper = styled.input`
  width: 100%;
  outline: none;
  margin: 0;
  border: 0;
  border-radius: 4px;
  font-size: 16px;
  font-family: ${FONTS.OPEN_SANS};
  color: ${COLORS.BLACK};
  box-sizing: border-box;
  width: 100%;
  padding: 10px 12px;
  border: 1px solid ${COLORS.GRAY};

  &::placeholder {
    color: ${COLORS.GRAY_PLACEHOLDER};
  }
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  & { -moz-appearance:textfield; }
  ${(props:Props) => props.disabled && css`
    user-select: none;
    pointer-events: none;
    opacity: 0.7;
    background: transparent;
  `}
  ${(props:Props) => props.error && css`
    border: 1px solid red;
  `}
`;

export const ErrorMessage = styled.span`
  color: red;
  font-size: 11px;
`;

export const IconLoading = styled.span`
  position: absolute;
  z-index: 10;
  right: 12px;
  top: 10px;
  svg {
    fill: transparent;
    stroke-width: 5px;
    stroke: #b7b0b0;
    stroke-dasharray: 100%;
    animation: rotate .5s linear infinite
  }

  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const Wrapper = styled.div`
  position: relative;
`;
